import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':itemId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:itemId`;

export const URL = (itemId: number): RouteDefinition => `${baseRoute}/${itemId}`;
